import {
  LayoutModeType,
  MenuMode,
  SidebarVisibility,
  UserStateExcludingUserFirstLoginPresenterModel,
} from '@osos/shared/types';
import { UserPreferences } from './user-preferences.state';
// tslint:disable-next-line: no-namespace
export namespace UserPreferencesActions {
  export class InitUserPreferences {
    static readonly type = '[User Preferences]  Set Default Preferences';
  }
  export class SetUserPreferences {
    static readonly type = '[User Preferences] Set Ui Preferences';
    constructor(public payload: UserPreferences) {}
  }

  export class SetFontSize {
    static readonly type = '[User Preferences] Set fontSize';
    constructor(public payload: number) {}
  }
  export class SetLayoutMode {
    static readonly type = '[User Preferences] Set layout mode';
    constructor(public payload: LayoutModeType) {}
  }
  export class SetMenuMode {
    static readonly type = '[User Preferences] Set menu mode';
    constructor(public payload: MenuMode) {}
  }

  export class SetIsFirstLogin {
    static readonly type = '[User Preferences]  Set is first login';
    constructor(public payload: boolean) {}
  }

  export class SetTourMode {
    static readonly type =
      '[User Preferences] Change Tour Mode and Enable or Disable it';
    constructor(
      public payload: {
        supported?: boolean;
        enabled?: boolean;
        currentTour?: number;
        toursStarted?: boolean;
      },
    ) {}
  }

  export class StartTours {
    static readonly type = '[User Preferences] Start Tours';
  }

  export class StopTours {
    static readonly type = '[User Preferences] Stop Tours';
  }

  export class DisableTours {
    static readonly type = '[User Preferences] Disable Tours';
  }

  export class UpdateSidebarVisibility {
    static readonly type = '[User Preferences] Update Sidebar Visibility';
    constructor(public payload: SidebarVisibility) {}
  }
  export class DisplayAvailableThemes {
    static readonly type = '[User Preferences] display Available theme';
  }
  export class DisplayAvailableTimeZones {
    static readonly type = '[User Preferences] display Available timeZone';
  }
  export class DisplayAvailableDates {
    static readonly type = '[User Preferences] Display Available Date Formats';
  }
  export class DisplayAvailableTimes {
    static readonly type = '[User Preferences] Display Available Time Formats';
  }
  export class DisplayAvailableDateTimes {
    static readonly type =
      '[User Preferences] Display Available DateTime Formats';
  }
  export class FetchUserStateData {
    static readonly type = '[User Preferences] Fetch User State Data';
  }
  export class UpdateUserStateData {
    static readonly type = '[User Preferences] update user state';
    constructor(
      public payload: UserStateExcludingUserFirstLoginPresenterModel,
    ) {}
  }
  export class ResetUserStateToDefault {
    static readonly type = '[User Preferences] reset user state to default';
  }
  export class GetBackendVersion {
    static readonly type = '[User Preferences] get backend version';
  }

  export class SetActiveDelegation {
    static readonly type = '[User Preferences] set Delegation';
    constructor(public delegationId: string | null) {}
  }
}
